import 'css-chunksrc/client/scenes/workloads/wbs/task/allocationsList/details/group/completion/completionInput/styles.scss';export default {
  "completionInput": "_completionInput_1sszo_1",
  "edition": "_edition_1sszo_7",
  "input": "_input_1sszo_11",
  "text": "_text_1sszo_31"
};